class ReportsApiResponseModel {
  // #region Props
  alias;
  categoria;
  descripcion;
  esPublico;
  habilitado;
  id;
  tipoInforme;
  titulo;
  url;
  // #endregion

  constructor(object) {
    // Assign props to this object instance
    for (const key in object) {
      if (Object.hasOwnProperty.call(object, key)) {
        const element = object[key];
        this[key] = element;
      }
    }
  }

  // #region Private methods
  // #endregion
}

export default ReportsApiResponseModel;
